import React from 'react'
import { Info } from '../NewIcons'
import Tooltip from '../Tooltip/Tooltip'
import { priceNotation } from '../../../utils/safe'

const Datatable = ({ cols, children }) => {
  return (
    <div className="datatable">
      <div className="datatable__head">
        {Object.values(cols).map((col, index) => (
          <DatatableHeadCell key={index} col={col} />
        ))}
      </div>
      {children}
    </div>
  )
}

export const DatatableHeadCell = ({ col }) => {
  // visibili sono nel desktop, quindi non gestisco i casi mobile
  return (
    <div
      onClick={col?.onClick}
      className={
        'datatable-headcell' +
        (col.hidden ? ' u-hidden' : '') +
        (col.desktopHidden ? ' u-hidden-desktop' : '') +
        (col.desktopCols ? ' datatable-cell--desktop-cols-' + col.desktopCols : '') +
        (col.align ? ' u-align-' + col.align : '') +
        (col.desktopAlign ? ' u-align-' + col.desktopAlign + '-desktop' : '')
      }
      style={
        col.width
          ? { flex: 'none', width: col.width ? col.width : null }
          : { flexGrow: col.grow ? col.grow : null }
      }
    >
      <DatatableHeading label={col.label} info={col.info} />
    </div>
  )
}

export const DatatableHeading = ({ label, info }) => {
  /* TODO: comportamento di Info? */
  return (
    <div className="datatable-heading">
      <span className="datatable-heading__label">{label}</span>
      {info && (
        <span className="datatable-heading__info">
          <Tooltip label={info}>
            <Info />
          </Tooltip>
        </span>
      )}
    </div>
  )
}

export const DatatableError = ({ error }) => {
  return error ? <div className="datatable-error">{error}</div> : <></>
}

export const DatatableRow = ({ children, extra, error, even, className }) => {
  return (
    <div
      className={
        'datatable-row' +
        (even ? '' : ' datatable-row--odd') +
        (className ? ' ' + className : '') +
        ' nobreak'
      }
    >
      <div className="datatable-row__cells">{children}</div>
      {extra && <div className="datatable-row__extra">{extra}</div>}
      {error && (
        <div className="datatable-row__error">
          <DatatableError error={error} />
        </div>
      )}
    </div>
  )
}

// Se non c'è il parametro col non visualizzo la cella
export const DatatableCell = ({ col, error, children, className, contentClassName }) => {
  return col ? (
    <div
      className={
        'datatable-cell' +
        (col.align ? ' u-align-' + col.align : '') +
        (col.desktopAlign ? ' u-align-' + col.desktopAlign + '-desktop' : '') +
        (col.mobileAlign ? ' u-align-' + col.mobileAlign + '-mobile' : '') +
        (col.mobileOrder ? ' datatable-cell--mobile-order-' + col.mobileOrder : '') +
        (col.desktopCols ? ' datatable-cell--desktop-cols-' + col.desktopCols : '') +
        (col.mobileCols ? ' datatable-cell--mobile-cols-' + col.mobileCols : '') +
        (col.mobileHidden ? ' u-hidden-mobile' : '') +
        (col.desktopHidden ? ' u-hidden-desktop' : '') +
        (col.hidden ? ' u-hidden' : '') +
        (className ? ' ' + className : '')
      }
      style={
        col.width
          ? { flex: 'none', width: col.width ? col.width : null }
          : { flexGrow: col.grow ? col.grow : null }
      }
    >
      {col.label && (
        <div className="datatable-cell__heading">
          <DatatableHeading label={col.label} info={col.info} />
        </div>
      )}
      <div className={`datatable-cell__content ${contentClassName ? contentClassName : ''}`}>{children}</div>
      {error && (
        <div className="datatable-cell__error">
          <DatatableError error={error} />
        </div>
      )}
    </div>
  ) : (
    <></>
  )
}

// Celle con valori tipizzati
export const DatatableCellPrice = ({ col, value }) => {
  return col ? (
    <DatatableCell col={col}>{value ? `${priceNotation(value, 3)} €` : ''}</DatatableCell>
  ) : (
    <></>
  )
}

export default React.memo(Datatable)
